import { InjectionToken } from '@angular/core';
import { ProductivityRulesPort } from './productivity-rules.port';

export const PRODUCTIVITY_RULES_PORT = new InjectionToken<ProductivityRulesPort>('PRODUCTIVITY_RULES_PORT');
